import { Button } from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import styles from './ThreadListRow.module.scss'

export default function ThreadListRowKebabMenuView({
  kebabRef,
  menuOpen,
  setMenuOpen,
  menuAnchorEl,
  setMenuAnchorEl,
  closeMenu,
  menuItems,
  isEditingTitle,
  onMenuClick,
  onMenuItemSelect,
  onThreadMenuAction,
  thread,
}) {
  return (
    <>
      <Button
        ref={kebabRef}
        type="button"
        variant="text"
        className={styles.kebab}
        sx={{ minWidth: '24px', width: '24px', maxWidth: '24px', padding: 0 }}
        aria-label="Thread options"
        aria-expanded={menuOpen}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation()
          if (menuOpen) closeMenu()
          else {
            setMenuAnchorEl(e.currentTarget)
            setMenuOpen(true)
          }
          onMenuClick?.(e)
        }}
      >
        <span className={styles.kebabDot} aria-hidden />
        <span className={styles.kebabDot} aria-hidden />
        <span className={styles.kebabDot} aria-hidden />
      </Button>
      <FloatingMenuPopup
        open={menuOpen}
        anchorEl={menuAnchorEl}
        onClose={closeMenu}
        items={menuItems}
        onItemSelect={(id) => {
          const proceed = onMenuItemSelect?.(id, closeMenu)
          if (proceed !== false && thread) onThreadMenuAction?.(thread, id)
        }}
        restoreFocusOnClose={!isEditingTitle}
      />
    </>
  )
}
